import React from "react";
import { connect } from "react-redux";

import * as profilesActions from "../../modules/Employees/redux/actions/profiles";
const { getEmployees } = profilesActions;

/*
  Вытаскивает список сотрудников из state.Emploees.profiles.data.active
  employeesConnect(Component); // все сотрудники
  employeesConnect(Component, ['driver', 'dispatcher']); // фильтр по роли
*/
const employeesConnect = (Component, filters) => {
  return connect(
    state => ({
      profiles:
        state.Employees.profiles.data && state.Employees.profiles.data.active
    }),
    {
      getEmployees
    }
  )(
    class extends React.PureComponent {
      state = {
        profiles: []
      };
      componentDidMount() {
        if (!this.props.profiles) {
          this.props.getEmployees();
        } else {
          this.setProfiles();
        }
      }
      componentDidUpdate(prevProps) {
        if (this.props.profiles !== prevProps.profiles) {
          this.setProfiles();
        }
      }
      getFullName = data => {
        return (
          `${data.lastname} ${data.name}` +
          (data.patronymic ? ` ${data.patronymic}` : "")
        );
      };
      setProfiles() {
        const { profiles } = this.props;
        let newProfiles = filters
          ? profiles.filter(
              item =>
                item.roleKey &&
                item.profileStatusKey === "active" &&
                filters.includes(item.roleKey)
            )
          : profiles;
        this.setState({
          profiles: newProfiles.map(profile => {
            let userName = "";
            if (profile) {
              userName += profile.lastname ? `${profile.lastname} ` : "";
              userName += profile.name ? `${profile.name[0]}.` : "";
              userName += profile.patronymic ? `${profile.patronymic[0]}.` : "";
            }
            return {
              profileId: profile.profileId,
              role: profile.role,
              roleKey: profile.roleKey,
              userName
            };
          })
        });
      }
      render() {
        return <Component {...this.props} profiles={this.state.profiles} />;
      }
    }
  );
};

export default employeesConnect;
